<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/engine/hubei/hb.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器湖北工厂
                </div>
                <div class="manufacture-t2">
                    为打造智慧化工厂，树立动力BU及行业标杆，湖北动力项目组于2025年2月份应运而生;<br />
                    位于湖北省大冶市，整体占地160亩，主要包含机加车间及装试车间，5条生产线，主要生产EN汽油发动机。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
            <div class="page-t2">
                涵盖生产线体、集中冷却系统，智能仓储区三大核心模块，是集数字化、智能化、绿色化于一体的现代化生产基地
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                缸体线
                            </div>
                            <div class="destils">
                                采用德国进口GROB品牌第5代加工中心、配合行业内领先的机器人清洗机，采用精镗+珩磨+工艺缸盖组合的工艺方案，缸孔表面粗糙度控制在Ra0.2-0.4μm，提升耐磨性与密封性
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/hubei/hb1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                缸盖线
                            </div>
                            <div class="destils">
                                采用德国进口GROB品牌第5代加工中心，缸盖燃烧室采用铣刀工艺加工，比传统铸造工艺拥有更高的表面质量，优化气流特性，提升燃烧效率
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/hubei/hb1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                曲轴线
                            </div>
                            <div class="destils">
                                曲轴线采用德国HELLER，赫根塞特滚压机等进口设备，以及美国等微米级测量设备，采用车拉+精磨+圆角滚压工艺，对轴颈采取淬火加工，表面硬度提升50%左右，圆角滚压后疲劳强度提升30%以上
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/hubei/hb1-3.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>
            <div class="page-t2">
                装试车间为恒温无尘全封闭车间，线体覆盖拧紧、压装、试漏、涂胶、涂油等核心工艺，线体自动化率达35%
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器湖北工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/hubei.html'
};

import { createApp } from 'vue';
import App from './hubei.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./hubei.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
